export const GetAllUserReports = async (user, location) => {
    try {

        const ApiURL = window.Links.ApiURL;
        const authToken = localStorage.getItem("authToken");

        const requestOptions = {

            method: "POST",
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${authToken}`
            },
            body: JSON.stringify({
                user: user,
                location: location
            })

        };

        const response = await fetch(`${ApiURL}Report/Get-Reports`, requestOptions);
        const responseData = await response.json();

        if (response.status === 200) {
            return { success: true, data: responseData.data };
        } else {
            console.error(`API request failed with status code: ${response.status}`);
            return { success: false, data: [] };
        }

    } catch (error) {
        console.error("Error fetching data:", error);
        return { success: false, data: [] };
    }
}



export const GetReportStructure = async (id) => {
    try {

        const ApiURL = window.Links.ApiURL;
        const authToken = localStorage.getItem("authToken");

        const requestOptions = {

            method: "GET",
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${authToken}`
            }
        };

        const response = await fetch(`${ApiURL}Report/GetReports/${id}`, requestOptions);
        const responseData = await response.json();

        if (response.status === 200) {
            if (responseData.success) {
                return { success: true, data: responseData.data };
            }
            return { success: false, data: responseData.data };
        } else {
            console.error(`API request failed with status code: ${response.status}`);
            return { success: false, data: {} };
        }

    } catch (error) {
        console.error("Error fetching data:", error);
        return { success: false, data: {} };
    }
}


export const SaveReport = async (report) => {
    try {
        const ApiURL = window.Links.ApiURL;
        const authToken = localStorage.getItem("authToken");

        const requestOptions = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${authToken}`
            },
            body: JSON.stringify(report)
        };

        const response = await fetch(`${ApiURL}Report`, requestOptions);
        const responseData = await response.json();

        if (response.status === 200 && responseData.success) {
            return true;
        }

        return false;

    } catch (error) {
        console.error("Error fetching data:", error);
        return false;
    }
}



export const GetReportDataUserWise = async (user, location) => {
    try {
        const ApiURL = window.Links.ApiURL;
        const authToken = localStorage.getItem("authToken");

        const requestOptions = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${authToken}`
            },
            body: JSON.stringify({
                user: user,
                location: location
            })
        };

        const response = await fetch(`${ApiURL}Report/GetReportDataUserWise`, requestOptions);
        const responseData = await response.json();

        if (response.status === 200 && responseData.success) {
            return { success: true, data: responseData.data };
        }

        return { success: false, data: [] };

    } catch (error) {
        console.error("Error fetching data:", error);
        return { success: false, data: [] };
    }
}


export const DownloadReport = async (jobId, pdfName) => {
    try {
        const ApiURL = window.Links.ApiURL;
        const authToken = localStorage.getItem("authToken");

        const requestOptions = {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`
            },
            body: JSON.stringify({
                jobId: parseInt(jobId),
                pdfName: pdfName
            })
        };

        const response = await fetch(`${ApiURL}Report/download`, requestOptions);

        // Check if the request was successful (status code in the range of 200-299)
        if (response.ok) {
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', pdfName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            return true;
        } else {
            // Handle unsuccessful response (status code outside the range of 200-299)
            const errorData = await response.json(); // Assuming the server returns JSON
            console.error('Error:', errorData);
            return false;
        }
    } catch (error) {
        console.error("Error:", error);
        return false;
    }
};


export const GetUserLocations = async (user) => {
    try {
        const ApiURL = window.Links.ApiURL;
        const authToken = localStorage.getItem("authToken");

        const requestOptions = {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${authToken}`
            }
        };

        const response = await fetch(`${ApiURL}Locations/selectl/${user}`, requestOptions);
        const responseData = await response.json();

        if (response.status === 200 && responseData.success) {
            return { success: true, data: responseData.data };
        }

        return { success: false, data: [] };

    } catch (error) {
        console.error("Error fetching data:", error);
        return { success: false, data: [] };
    }
}


export const GetTransactionDropdown = async () => {
    try {
        const ApiURL = window.Links.ApiURL;
        const authToken = localStorage.getItem("authToken");

        const requestOptions = {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${authToken}`
            }
        };

        const response = await fetch(`${ApiURL}txn/dropdown`, requestOptions);
        const responseData = await response.json();

        if (response.status === 200 && responseData.success) {
            return { success: true, data: responseData.data };
        }

        return { success: false, data: [] };

    } catch (error) {
        console.error("Error fetching data:", error);
        return { success: false, data: [] };
    }
}
